import axios from "axios";

import { setupInterceptorsTo } from "./interceptors";

const private_api = setupInterceptorsTo(
  axios.create({
    baseURL: import.meta.env.VITE_APP_BACKEND_URL,
    headers: {
      "Content-Type": "application/json",
    },
  }),
);

export default private_api;

export { logout } from "./privateRequests/user/logout";
export { createCheckoutSession } from "./privateRequests/stripe/createCheckoutSession";
export { getUser } from "./privateRequests/user/getUser";
export { patchUser } from "./privateRequests/user/patchUser";
export { getNumberOfPlayersInClub } from "./privateRequests/players/getNumberOfPlayersInClub";
export { deleteAllPlayers } from "./privateRequests/players/deleteAllPlayers";
export { deleteSpecificPlayers } from "./privateRequests/players/deleteSpecificPlayers";
export { createCustomerPortalSession } from "./privateRequests/stripe/createCustomerPortalSession";
export { verifyPayment } from "./privateRequests/stripe/verify-payment";
export { markSbcSolved } from "./privateRequests/sbcs/markSbcSolved";
export { getSbcSets } from "./privateRequests/sbcs/getSbcSets";
export { getSbcs } from "./privateRequests/sbcs/getSbcs";
export { getSbcSet } from "./privateRequests/sbcs/getSbcSet";
export { getSbc } from "./publicRequests/sbcs/getSbc";
export { playerSwap } from "./privateRequests/sbcs/player-swap";
export { putUserSbcSolution } from "./privateRequests/sbcs/putUserSbcSolution";
export { fetchPrices } from "./privateRequests/user/fetchPrices";
export { postEvent } from "./privateRequests/events/postEvent";
export { solveSbcSolutions } from "@repo/shared/api";

// Formerly exported from publicApi (deleted). These request fns hit the same
// interceptor-enabled instances; auth fns use authApi (no 401 redirect).
export { login } from "./publicRequests/login";
export { appleLogin } from "./publicRequests/appleLogin";
export { sendMessage } from "./publicRequests/user/sendMessage";
export { loginWithEmail } from "./publicRequests/login-with-email";
export { confirmLoginWithCode } from "./publicRequests/confirm-login";
export { unsubscribeEmail } from "./publicRequests/user/unsubscribe-email";
